module.exports = __webpack_public_path__ + "media/images/river/FlatCrewnecks-5e51527f70bbda65845027ec119b8cbd.png";